import React from 'react';
import ReactDOM from 'react-dom';
import {ConfigProvider} from 'antd';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css'
import it_IT from 'antd/lib/locale-provider/it_IT';
import AppRouter from "./router/AppRouter";
import {PermissionStore} from "./context/PermissionContext";
import {PureAbility} from "@casl/ability";
import Spinner from "./layout/Spinner";
import Main from "./Main";

import {ReactKeycloakProvider} from '@react-keycloak/web'
import {AuthClientError, AuthClientEvent} from '@react-keycloak/core';
import keycloak from './keycloak';
//import {generate} from "generate-password";

//import './i18';
export const ROOT_PATH =  process.env.PUBLIC_URL;
//const keycloakObj: Keycloak.KeycloakInstance = Keycloak(`${ROOT_PATH}/keycloak.json`);

var container = document.getElementById('root');
const keycloakProviderInitConfig = {
    onLoad: "check-sso",
};
/*
const password = generate({
    length: 10,
    uppercase: true,
    symbols: true,
    numbers: true,
    strict: true
});

console.log('PASSWORD: ', password);
*/
ReactDOM.render(
    <React.StrictMode>
        <React.Suspense fallback={<Spinner/>}>
            <ReactKeycloakProvider
                authClient={keycloak}
                initOptions={keycloakProviderInitConfig}
                onEvent={(event: AuthClientEvent, error?: AuthClientError) => {

                    switch (event) {
                        case 'onAuthRefreshError':
                        case 'onAuthLogout':
                        case 'onAuthError':
                            keycloak.logout();
                            break;
                        default:
                            break;
                    }
                    if (error !== undefined) {
                        keycloak.logout();
                    }

                }}
            >
                <PermissionStore
                    ability={new PureAbility<[string, string]>()}
                >
                    <ConfigProvider locale={it_IT}>
                        <Main>
                            <AppRouter />
                        </Main>
                    </ConfigProvider>
                </PermissionStore>
            </ReactKeycloakProvider>
        </React.Suspense>
    </React.StrictMode>,
    container
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
